export const bootcampCategoryLanguageKeyMap: { [key: string]: string } = {
  algebra: 'algebra',
  geometry: 'geometry',
  'numbers-and-quantities': 'numbersAndQuantities',
  'statistics-and-probability': 'statisticsAndProbability',
  functions: 'functions',
  proofs: 'proofs',
}
